export function isArray(arr: any): boolean {
  return Array.isArray(arr);
}
